import axios from 'axios';
import { API_BASE_URL } from '../../constants';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchAnalyticsOverview = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/analytics/overview/`, {
    headers: authHeaders(),
  });
  return res.data || {};
};

export const fetchAnalyticsEvents = async ({ from, to, type, actor, limit } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (type) params.type = type;
  if (actor) params.actor = actor;
  if (limit) params.limit = limit;
  const res = await axios.get(`${API_BASE_URL}/admin/analytics/events/`, {
    headers: authHeaders(),
    params,
  });
  return res.data || {};
};

export const downloadAnalyticsEventsCsv = ({ from, to, type, actor } = {}) => {
  const params = new URLSearchParams();
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  if (type) params.append('type', type);
  if (actor) params.append('actor', actor);
  const url = `${API_BASE_URL}/admin/analytics/events/csv/?${params.toString()}`;
  const token = localStorage.getItem('token');
  // Use fetch + blob so the auth header gets attached.
  return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.blob())
    .then((blob) => {
      const u = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = u;
      a.download = 'events.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(u);
    });
};
